import { lazy } from "react";
import {
  enumPermisosAgrario,
  enumPermisosAgrarioGestion,
} from "./enumPermisosAgrario";
import RegisterElectronicTally from "./ElectronicTally/RegisterElectronicTally";
import ListElectronicTally from "./ElectronicTally/ListElectronicTally";
import UploadElectronicTally from "./ElectronicTally/ChargeElectronicTally";

/** Componente de iconos */
const AppIcons = lazy(() => import("../../../components/Base/AppIcons"));

/**
 * Corresponsalia Banco Agrario
 */
const CorresponsaliaBancoAgrario = lazy(() =>
  import("./CorresponsaliaBancoAgrario")
);
const AdminGestionAgrario = lazy(() => import("./AdminGestionAgrario"));
const PagarRunt = lazy(() => import("./Views/Runt/PagarRunt"));

const PagoCarteraEfectivo = lazy(() =>
  import("./Views/PagoCartera/PagoCarteraEfectivo/PagoCarteraEfectivo.jsx")
);

const PagoTarjCredito = lazy(() =>
  import("./Views/PagoCartera/PagoTarjCredito/PagoTarjCredito.jsx")
);

const TrxCuentasBancoAgrario = lazy(() =>
  import("./CorresponsaliaBancoAgrario")
);
const RetiroEfectivoBancoAgrario = lazy(() =>
  import("./Views/TrxCuentas/RetiroEfectivo")
);
const DepositoBancoAgrario = lazy(() =>
  import("./Views/TrxCuentas/DepositoEfectivo")
);
const ConveniosRecaudoAgrario = lazy(() =>
  import("./Views/RecaudoServiciosPublicosPrivados/ConveniosRecaudoAgrario")
);
const RecaudoServiciosPublicosPrivadosAgrario = lazy(() =>
  import(
    "./Views/RecaudoServiciosPublicosPrivados/RecaudoServiciosPublicosPrivadosAgrario"
  )
);
const RecaudoServiciosPublicosPrivadosLecturaCodigoBarrasAgrario = lazy(() =>
  import(
    "./Views/RecaudoServiciosPublicosPrivados/RecaudoServiciosPublicosPrivadosLecturaCodigoBarrasAgrario"
  )
);
const SeleccionServicioPagarAgrario = lazy(() =>
  import(
    "./Views/RecaudoServiciosPublicosPrivados/SeleccionServicioPagarAgrario"
  )
);
const RecaudoServiciosPublicosPrivadosMenuAgrario = lazy(() =>
  import("./Views/RecaudoServiciosPublicosPrivadosMenuAval")
);

const AdminElectronicTally = lazy(() => import("./ElectronicTally/AdminElectronicTally"));

const listPermissions = Object.values(enumPermisosAgrario);
export const listPermissionsAgrario = listPermissions;
export const listPermissionsGestionAgrario = Object.values(
  enumPermisosAgrarioGestion
);

const rutasAgrarioCB = {
  link: "/corresponsalia/corresponsalia-banco-agrario",
  label: <AppIcons Logo={"AGRARIO"} name="Corresponsalía Banco Agrario" />,
  component: CorresponsaliaBancoAgrario,
  permission: [...listPermissionsAgrario],
  subRoutes: [
    {
      link: "/corresponsalia/corresponsalia-banco-agrario/transacciones-cuentas",
      label: (
        <AppIcons
          Logo={"MARKETPLACE"}
          name="Transacciones cuentas Banco Agrario"
        />
      ),
      component: TrxCuentasBancoAgrario,
      permission: [
        enumPermisosAgrario.agrario_cb_depositos,
        enumPermisosAgrario.agrario_cb_retiros,
      ],
      subRoutes: [
        {
          link: "/corresponsalia/corresponsalia-banco-agrario/transacciones-cuentas/deposito",
          label: <AppIcons Logo={"MARKETPLACE"} name="Depósito" />,
          component: DepositoBancoAgrario,
          permission: [enumPermisosAgrario.agrario_cb_depositos],
        },
        {
          link: "/corresponsalia/corresponsalia-banco-agrario/transacciones-cuentas/retiro",
          label: <AppIcons Logo={"MARKETPLACE"} name="Retiro" />,
          component: RetiroEfectivoBancoAgrario,
          permission: [enumPermisosAgrario.agrario_cb_retiros],
        },
      ],
    },
    {
      link: "/corresponsalia/corresponsalia-banco-agrario/recaudoServiciosPublicosPrivados",
      label: (
        <AppIcons
          Logo={"MARKETPLACE"}
          name="Recaudo servicios públicos y privados"
        />
      ),
      component: RecaudoServiciosPublicosPrivadosMenuAgrario,
      permission: [
        enumPermisosAgrario.agrario_cb_recaudo,
        enumPermisosAgrario.agrario_cb_convenios_recaudo,
      ],
      subRoutes: [
        {
          link: "/corresponsalia/corresponsalia-banco-agrario/recaudoServiciosPublicosPrivados/seleccion",
          label: <AppIcons Logo={"MARKETPLACE"} name="Recaudo manual" />,
          component: SeleccionServicioPagarAgrario,
          permission: [enumPermisosAgrario.agrario_cb_recaudo],
        },
        {
          link: "/corresponsalia/corresponsalia-banco-agrario/recaudoServiciosPublicosPrivados/codbarras",
          label: (
            <AppIcons Logo={"MARKETPLACE"} name="Recaudo código de barras" />
          ),
          component: RecaudoServiciosPublicosPrivadosLecturaCodigoBarrasAgrario,
          permission: [enumPermisosAgrario.agrario_cb_recaudo],
        },
        {
          link: "/corresponsalia/corresponsalia-banco-agrario/recaudoServiciosPublicosPrivados/manual",
          label: <AppIcons Logo={"MARKETPLACE"} name="Recaudo manual" />,
          component: RecaudoServiciosPublicosPrivadosAgrario,
          permission: [enumPermisosAgrario.agrario_cb_recaudo],
          show: false,
        },
      ],
    },

    {
      link: "/runt/pagar-runt",
      label: <AppIcons Logo={"DAVIVIENDA_PAGO_POR_GIRO"} name={"Pagar RUNT"} />,
      component: PagarRunt,
      permission: [enumPermisosAgrario.agrario_cb_runt],
    },
    {
      link: "/corresponsalia/corresponsalia-banco-agrario/recaudo-de-productos-propios",
      label: (
        <AppIcons Logo={"MARKETPLACE"} name="Recaudo de productos propios" />
      ),
      component: RecaudoServiciosPublicosPrivadosMenuAgrario,
      permission: [
        enumPermisosAgrario.pago_cartera_targ_credito,
        enumPermisosAgrario.pago_cartera_efectivo,
      ],
      subRoutes: [
        {
          link: "/corresponsalia/corresponsalia-banco-agrario/recaudo-de-productos-propios/pago-cartera-tarjeta-credito",
          label: (
            <AppIcons Logo={"MARKETPLACE"} name={"Pago de tarjeta crédito"} />
          ),
          component: PagoTarjCredito,
          permission: [enumPermisosAgrario.pago_cartera_targ_credito],
          subRoutes: [],
        },
        {
          link: "/corresponsalia/corresponsalia-banco-agrario/recaudo-de-productos-propios/pago-cartera-efectivo",
          label: <AppIcons Logo={"MARKETPLACE"} name={"Pago de Cartera"} />,
          component: PagoCarteraEfectivo,
          permission: [enumPermisosAgrario.pago_cartera_efectivo],
          subRoutes: [],
        },
      ],
    },
  ],
};
export const rutasGestionAgrario = {
  link: "/GestionTransaccional/corresponsalia-banco-agrario",
  label: <AppIcons Logo={"MARKETPLACE"} name="Gestión Banco Agrario" />,
  component: AdminGestionAgrario,
  permission: [enumPermisosAgrarioGestion.agrario_cb_convenios_recaudo],
  subRoutes: [
    {
      link: "/GestionTransaccional/corresponsalia-banco-agrario/convenios",
      label: <AppIcons Logo={"MARKETPLACE"} name="Convenios recaudo Agrario" />,
      component: ConveniosRecaudoAgrario,
      permission: [enumPermisosAgrarioGestion.agrario_cb_convenios_recaudo],
    },
  ],
};

export const routesElectronicTally ={
  link: "/GestionTransaccional/punteo-electronico",
  label: <AppIcons Logo={"MARKETPLACE"} name="Punteo Electrónico" />,
  component: AdminElectronicTally,
  permission: [enumPermisosAgrarioGestion.electronic_tally],
  subRoutes: [
    {
      link: "/GestionTransaccional/punteo-electronico/registrar",
      label: <AppIcons Logo={"MARKETPLACE"} name="Registro de Información" />,
      component: RegisterElectronicTally,
      permission: [enumPermisosAgrarioGestion.electronic_tally],
    },
    {
      link: "/GestionTransaccional/punteo-electronico/lista",
      label: <AppIcons Logo={"MARKETPLACE"} name="Cargue de Soporte" />,
      component: ListElectronicTally,
      permission: [enumPermisosAgrarioGestion.electronic_tally],
    },
    {
      link: "/GestionTransaccional/punteo-electronico/cargar",
      label: <AppIcons Logo={"MARKETPLACE"} name="Cargar Ticket Punteo Electrónico" />,
      component: UploadElectronicTally,
      permission: [enumPermisosAgrarioGestion.electronic_tally],
      show: false
    },
  ],
};

export default rutasAgrarioCB;
